import React, {useEffect, useState} from "react";
import {useSelector} from "../../shared-services/redux-tiny";
import useCartButtons from "./useCartButtons";

const currencyDecimals = 2;
export const parsePrice = (price) => price ? parseFloat(price).toFixed(currencyDecimals) : null;
const splitPrice = (price) => price || price === 0 ? price.toString().split(/\.|,/) : [];

const useProductPrice = (product) => {
  const {currentUser, currency} = useSelector(state => state.session);
  const {lineItem} = useCartButtons(product);
  const ffProduct = product?.eligible_for_ffamily && product?.strikeout_price;

  const pricePerUnit = parsePrice(product?.price_per_100g);
  const strikeoutPricePerUnit = parsePrice(product?.strikeout_price);
  const pricePerUnitLabel = product?.price_per_100g_denominator;

  const [price, setPrice] = useState(product?.price);
  const [strikeoutPrice, setStrikeoutPrice] = useState(product?.strikeout_price);
  const [packagePrice, setPackagePrice] = useState(product?.package_price || null);
  const [useDiscount, setUseDiscount] = useState(false);

  const canUseDiscount = () => {
    const canSeeFarmyFamilyPrice = true;
    const farmyFamilyUser = currentUser?.ff_subscriber || false;
    const canDoFFamily = canSeeFarmyFamilyPrice && farmyFamilyUser;

    return product?.strikeout_price && (!ffProduct || (ffProduct && canDoFFamily));
  };

  const setPrices = () => {
    const useDiscount = canUseDiscount();
    let displayPrice = lineItem?.total;
    if (!displayPrice) displayPrice = (!product.strikeout_price || useDiscount) ? product.price : product.strikeout_price;

    setPrice(parsePrice(displayPrice));
    const discountPrice = product?.strikeout_price && !useDiscount ? product.price : product.strikeout_price;
    const quantity = lineItem?.variant?.quantity_in_units || 1;

    setStrikeoutPrice(parsePrice(discountPrice * quantity));
    setPackagePrice(parsePrice(product?.package_price * quantity));

    setUseDiscount(canUseDiscount());
  };

  useEffect(() => {
    if (currentUser) {
      setPrices();
    }
  }, [currentUser]);

  useEffect(() => {
    setPrices();
  }, [lineItem]);

  return {
    price,
    strikeoutPrice,
    packagePrice,
    pricePerUnit,
    strikeoutPricePerUnit,
    pricePerUnitLabel,
    splitPrice,
    currency,
    useDiscount,
    StrikeoutPrice
  };
};

export default useProductPrice;

export const StrikeoutPrice = (props) => {
  const {currency, price, className = "", style} = props;

  return (
    <div
      className={`strikeout-price display-inline-block ${className}`}
      style={style}
    >
      <hr className="strikeout-hr"/>
      <div>
        {currency}
        {price}
      </div>
    </div>
  );
};

export const PriceSuperscript = (props) => {
  const {price, showCurrency = false, fontSize = null, className = "", style} = props;
  const parsedPrice = splitPrice(parsePrice(price));

  const {currency} = useSelector(state => state.session);

  return <div className={`inline-flex ${className}`} style={style}>
    <div className="flex">
      <span style={{fontSize}}>
        {showCurrency && <span className='margin-right-5'>
          {currency}
        </span>}

        {parsedPrice[0]}
        .
      </span>

      <span
        style={{
          marginLeft: "-0.2em",
          fontSize: "0.6em",
          marginTop: ".1em"
        }}
      >
        {parsedPrice[1] || "00"}
      </span>
    </div>
  </div>;
};
